const getPriceSpecificationConfig = ({
  displayPrice,
  vat
}) => {
  const { currency, originalPrice, discountedPrice, discountInfo } = displayPrice;
  const { validFrom, validUntil: validThrough } = discountInfo || {};
  const discountedPriceAmount = discountedPrice ?? 0;
  const price = discountedPriceAmount > 0 ? discountedPriceAmount : originalPrice;
  const vatRate = vat ? vat : 0;
  return {
    price,
    vatRate,
    currency,
    validFrom,
    validThrough
  };
};
export {
  getPriceSpecificationConfig
};
//# sourceMappingURL=get-price-specification-config.js.map
